export type BallLevel = "red" | "orange" | "green" | "yellow";

export const HOT_SHOTS_STAGES: Record<
  BallLevel,
  {
    label: string;
    emoji: string;
    color: string;
    bgColor: string;
    borderColor: string;
    dotColor: string;
    description: string;
    next: BallLevel | null;
  }
> = {
  red: {
    label: "Red Ball",
    emoji: "🔴",
    color: "text-red-700",
    bgColor: "bg-red-50",
    borderColor: "border-red-400",
    dotColor: "bg-red-500",
    description: "Learning the basics on a short court with a soft foam ball.",
    next: "orange",
  },
  orange: {
    label: "Orange Ball",
    emoji: "🟠",
    color: "text-orange-700",
    bgColor: "bg-orange-50",
    borderColor: "border-orange-400",
    dotColor: "bg-orange-500",
    description:
      "Building consistency from the mid-court with a slower orange ball.",
    next: "green",
  },
  green: {
    label: "Green Ball",
    emoji: "🟢",
    color: "text-green-700",
    bgColor: "bg-green-50",
    borderColor: "border-green-400",
    dotColor: "bg-green-500",
    description:
      "Match-play ready on a full singles court with a slightly slower ball.",
    next: "yellow",
  },
  yellow: {
    label: "Yellow Ball",
    emoji: "🎾",
    color: "text-yellow-700",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-500",
    dotColor: "bg-yellow-500",
    description:
      "Full game with a standard ball — ready for open tournaments.",
    next: null,
  },
};
